<template>
    <v-container fluid >
        <Formulario :getParams="this.params"></Formulario>
    </v-container>
</template>

<script>
import Formulario from "./components/Formulario.vue";
import Auth from "@/services/auth";
export default {
    name: "AdministracionPlantillasNuevo",
    data() {
        return {
            permisos: [],
            params: {
                plantilla_certificado_id: null,
            }
        }
    },
    components: {
        Formulario
    },
    methods: {
        regresar() {
            this.$router.go(-1)
        }
    },
    created() {
        Auth.checkPermisos("/administracion/plantillas-certificados").then((res) => {
            this.permisos = res;
            if (!this.permisos[2]) {
                this.regresar();
            }
        });
    }
}
</script>

<style>

</style>
